import { useLocation, useNavigate } from "react-router-dom";
import { URLdecode, URLencode } from "../utils/url";
import { configurations } from "../configurations";

export default function useErrors() {
  const navigate = useNavigate();
  const location = useLocation();

  const accommodationSearchError = ({ data, status }) => {
    const params = URLdecode();
    const errors = data?.data?.detail || [];
    let IsTodayOrFutureConstraint = errors?.filter((item) =>
      Boolean(item?.constraints?.IsTodayOrFutureConstraint)
    );
    IsTodayOrFutureConstraint = IsTodayOrFutureConstraint?.map(
      (item) => item?.property
    );
    let errorCode = IsTodayOrFutureConstraint?.join("_");
    let payload = errors?.reduce((acc, curr) => {
      acc[curr?.property] = curr.value;
      return acc;
    }, {});
    if (errorCode) {
      const parameters = {
        ...params,
        error: true,
        errorPayload: JSON.stringify(payload),
        errorType: configurations.errors.accommodationSearch,
        errorCode,
      };

      navigate(`${location.pathname}?${URLencode(parameters)}`);
    }
  };

  const accommodationAvailabilityError = ({ data, status }) => {
    const params = URLdecode();
    const errors = data?.data?.detail || [];
    let errorCode = "";
    let payload = {};
    if (errors?.length) {
      let IsTodayOrFutureConstraint = errors?.filter((item) =>
        Boolean(item?.constraints?.IsTodayOrFutureConstraint)
      );
      IsTodayOrFutureConstraint = IsTodayOrFutureConstraint?.map(
        (item) => item?.property
      );
      errorCode = IsTodayOrFutureConstraint?.join("_");
      payload = errors?.reduce((acc, curr) => {
        acc[curr?.property] = curr.value;
        return acc;
      }, {});
    } else {
      if (data?.data?.code === 11) {
        errorCode = configurations.errorCodes.accommodationNoAvailability;
      }
    }
    if (errorCode) {
      const parameters = {
        ...params,
        error: true,
        errorPayload: JSON.stringify(payload),
        errorType: configurations.errors.accommodationAvailbility,
        errorCode,
      };

      navigate(`${location.pathname}?${URLencode(parameters)}`);
    }
  };

  const paymentError = ({ data, status, type }) => {
    const params = URLdecode();
    let parameters = { ...params, error: true, errorType: type };
    let payload = {};
    switch (data?.code) {
      case 82:
        parameters = {
          ...parameters,
          errorCode: 82,
        };
        payload = {
          balance: data?.currentBalance,
        };
        break;

      default:
        parameters = {
          ...parameters,
          errorCode: data?.code,
        };
        break;
    }
    if (data?.code === 82) {
      let payload = {
        balance: data?.currentBalance,
      };
      parameters = {
        ...params,
        error: true,
        errorPayload: JSON.stringify(payload),
        errorType: type,
        errorCode: data?.code,
      };
    }
    navigate(`${location.pathname}?${URLencode(parameters)}`);
  };

  const accommodationCancellationError = ({ data, status }) => {
    const params = URLdecode();
    if (data?.code === 10) {
      const parameters = {
        ...params,
        error: true,
        errorType: configurations.errors.accommodationCancellation,
        errorCode: data?.code,
      };
      navigate(`${location.pathname}?${URLencode(parameters)}`);
    }
  };

  const accommodationFareUpdateError = ({ data, status }) => {
    const params = URLdecode();
    if (data?.code === 10) {
      const parameters = {
        ...params,
        error: true,
        errorType: configurations.errors.accommodationFareUpdate,
        errorCode: data?.code,
      };
      navigate(`${location.pathname}?${URLencode(parameters)}`);
    }
  };

  return {
    accommodationSearchError,
    accommodationAvailabilityError,
    paymentError,
    accommodationCancellationError,
    accommodationFareUpdateError,
  };
}
